import styled from "styled-components";

export const FooterWrapper = styled.div`

background-color: #DFE4EA;
position: fixed;
bottom: 0;
width: 100%;
z-Index:5;
h5{
    font-size: 12px;
    padding: 14px 0;
}


`;